'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.isTabletQuery = exports.isDesktopQuery = exports.isMobileQuery = exports.isPhoneQuery = void 0;
var tslib_1 = require("tslib");
var magic_messages_1 = require("@gig/magic-messages");
function isPhoneQuery() {
    var _a;
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, window.queryBus.query(magic_messages_1.DEVICE_QUERY_IS_PHONE)];
                case 1: return [2 /*return*/, ((_a = (_b.sent())) !== null && _a !== void 0 ? _a : false)];
            }
        });
    });
}
exports.isPhoneQuery = isPhoneQuery;
function isMobileQuery() {
    var _a;
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, window.queryBus.query(magic_messages_1.DEVICE_QUERY_IS_MOBILE)];
                case 1: return [2 /*return*/, ((_a = (_b.sent())) !== null && _a !== void 0 ? _a : false)];
            }
        });
    });
}
exports.isMobileQuery = isMobileQuery;
function isDesktopQuery() {
    var _a;
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, window.queryBus.query(magic_messages_1.DEVICE_QUERY_IS_DESKTOP)];
                case 1: return [2 /*return*/, ((_a = (_b.sent())) !== null && _a !== void 0 ? _a : false)];
            }
        });
    });
}
exports.isDesktopQuery = isDesktopQuery;
function isTabletQuery() {
    var _a;
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, window.queryBus.query(magic_messages_1.DEVICE_QUERY_IS_TABLET)];
                case 1: return [2 /*return*/, ((_a = (_b.sent())) !== null && _a !== void 0 ? _a : false)];
            }
        });
    });
}
exports.isTabletQuery = isTabletQuery;
